import { useNavigate } from '@tanstack/react-router';

import { DashboardHome } from '@/features/dashboard-home/DashboardHome';

import { kpiDrillToCampaignsSearch, wizardInitToCampaignsSearch } from './routes';

/**
 * Route adapter for /dashboard (SCRUM-616). Converts DashboardHome's navigation
 * callbacks into router navigations:
 *   - onOpenReferrals(assignedToMe) -> /referrals?scope=mine|all
 *   - onStartOutreach(referral)     -> /campaigns?wizard=1&targets=...&...
 * This replaces the AppShell setActiveId + pending* useState hand-off.
 */
export function DashboardRoute() {
  const navigate = useNavigate();
  return (
    <DashboardHome
      onOpenReferrals={(assignedToMe) => {
        void navigate({ to: '/referrals', search: { scope: assignedToMe ? 'mine' : 'all' } });
      }}
      onStartOutreach={(referral) => {
        void navigate({
          to: '/campaigns',
          search: wizardInitToCampaignsSearch({
            targetIds: referral.customerId ? [referral.customerId] : [],
            productId: referral.productId || null,
            productPreSelected: Boolean(referral.productId),
            campaignName: `${referral.productName} — ${referral.customerName} referral`,
            linkedReferralId: referral.id,
          }),
        });
      }}
      onOpenCampaignsFiltered={(target) => {
        // SCRUM-847: KPI drill-through → Campaigns pre-filtered to that card's population.
        void navigate({ to: '/campaigns', search: kpiDrillToCampaignsSearch(target) });
      }}
    />
  );
}
